export function throwIfFalsy<T>(x: T | null | undefined, message = 'This should never happen'): asserts x is T {
    if (!x) {
        throw new Error(message);
    }
}
